import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';

const ITextModelService = createDecorator('textModelService');

export { ITextModelService };
